import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/app/layout/AppLayout';
import { SessionGate } from '@/modules/identity/public';

/**
 * Todo o backoffice. Sem sessão, manda para o login guardando a origem;
 * com sessão de aluno, o `SessionGate` bloqueia — só instrutor e admin.
 */
export const Route = createFileRoute('/_admin')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login', search: { redirect: location.href } });
    }
  },
  component: () => (
    <SessionGate>
      <AppLayout>
        <Outlet />
      </AppLayout>
    </SessionGate>
  ),
});
